import axios from "axios";
import {getToken} from "./auth.service";

const generateOwnGroupEndpoint = (
  search: String,
  limit: any,
  offset: any,
  type: any,
  mainType: string = ""
) => {
  const _type = type !== null ? type : "";
  return `api/v2/groups/?search=${search}&limit=${limit}&offset=${offset}&type=${_type}&maintype=${mainType}&isMyGroup=false&isOwner=true`;
};

const generateMyGroupEndpoint = (
  search: String,
  limit: any,
  offset: any,
  type: any,
  mainType: string = ""
) => {
  const _type = type !== null ? type : "";
  return `api/v2/groups/?search=${search}&limit=${limit}&offset=${offset}&type=${_type}&maintype=${mainType}&isMyGroup=true`;
};

const generateFindAllEndpoint = (
  search: String,
  limit: any,
  offset: any,
  type: any,
  mainType: string = ""
) => {
  const _type = type !== null ? type : "";
  return `api/v2/groups/?search=${search}&limit=${limit}&offset=${offset}&isMyGroup=false&type=${_type}&maintype=${mainType}`;
};

const generateDetailEndpoint = (groupId: any) => {
  return `api/v2/groups/${groupId}`;
};

const generateMemberEndpoint = (groupId: any) => {
  return `api/v2/groups/members/${groupId}`;
};

const generateMemberLocationEndpoint = (groupId: any) => {
  return `api/v2/groups/members-location?id=${groupId}`;
};

const generateZoneListEndpoint = () => {
  return `api/v1/locations/`;
};

export const APIEndpoint = {
  ownGroup: generateOwnGroupEndpoint,
  myGroup: generateMyGroupEndpoint,
  findAll: generateFindAllEndpoint,
  detail: generateDetailEndpoint,
  member: generateMemberEndpoint,
  memberLocation: generateMemberLocationEndpoint,
  zoneList: generateZoneListEndpoint,
  files: "api/v1/files",
  groups: "api/v2/groups/",
  request: "api/v2/groups/request",
  editGroup: "api/v2/groups/edit-group",
};

export const findOwnGroup = async (
  search: String,
  limit: any,
  offset: any,
  type: any,
  mainType: string = ""
) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
      APIEndpoint.ownGroup(search, limit, offset, type, mainType),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const findMyGroup = async (
  search: String,
  limit: any,
  offset: any,
  type: any,
  mainType: string = ""
) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
      APIEndpoint.myGroup(search, limit, offset, type, mainType),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const findAll = async (
  search: String,
  limit: any,
  offset: any,
  type: any,
  mainType: string = ""
) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
      APIEndpoint.findAll(search, limit, offset, type, mainType),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const detail = async (groupId: any) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.detail(groupId),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const member = async (groupId: any) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.member(groupId),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const memberLocation = async (groupId: any) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.memberLocation(groupId),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const getGroupMemberInfo = async (groupId: any) => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.memberLocation(groupId),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};

export const zoneList = async () => {
  return await axios.get(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.zoneList(),
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );
};
